export enum AwardPricePosition {
  DISCOUNT = 'DISCOUNT',
  MINSTREAM = 'MINSTREAM',
  PREMIUM = 'PREMIUM',
  LUXURY = 'LUXURY',
}
